/**
 * @generated SignedSource<<e1567717610a3bca9c715a7ab7136773>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DesignAdaptAlghoritm = "FIT_WITH_BACKGROUND" | "NONE" | "PERCENTAGE";
export type DesignItemTagTypes = "NONE" | "SYNC_COLORS" | "TEAMWEAR";
export type DesignInput = {
  adaptItemsToVariants: DesignAdaptAlghoritm;
  additionalAttributes?: ReadonlyArray<SelectedAdditionalAttributesInput | null> | null;
  areas?: ReadonlyArray<DesignAreaInput | null> | null;
  areasGrids?: ReadonlyArray<DesignAreaGridInput | null> | null;
  cameraScreenshots?: ReadonlyArray<DesignCameraScreenshotInput | null> | null;
  canAddImage: boolean;
  canAddShape: boolean;
  canAddText: boolean;
  canBeSetAsDefaultTemplate: boolean;
  canChangeSvgColors: boolean;
  canMaskImages: boolean;
  canvasRotation?: ReadonlyArray<DesignCanvasRotationInput | null> | null;
  categories?: ReadonlyArray<DesignTemplateCategoryInput | null> | null;
  clientPreviews?: ReadonlyArray<DesignClientPreviewInput | null> | null;
  colors?: ReadonlyArray<DesignTemplateColorInput | null> | null;
  compositionDocID?: string | null;
  compositionID: number;
  compoundKey?: string | null;
  createdBy: number;
  createdOn?: string | null;
  currentModificationID?: any | null;
  customerCode?: string | null;
  customerID: number;
  description?: string | null;
  designID: number;
  designItems?: ReadonlyArray<DesignItemInput | null> | null;
  designTempPreviews?: ReadonlyArray<DesignTempPreviewInput | null> | null;
  disableSellerImages?: boolean | null;
  docID?: string | null;
  elementsDescs?: ReadonlyArray<DesignElementsDescInput | null> | null;
  filterCode?: string | null;
  finalPrice: number;
  hasSyncEnabled: boolean;
  interfaceID?: number | null;
  isDeleted: boolean;
  isDraft: boolean;
  isLibrary: boolean;
  isTemplate: boolean;
  marketPlaceOrderID?: number | null;
  maxNrImages?: number | null;
  maxNrShapes?: number | null;
  maxNrTexts?: number | null;
  modelCode?: string | null;
  modelID: number;
  modelImageBasePrice: number;
  modelName?: string | null;
  modelPrice: number;
  modelPriceDeltaPerc: number;
  modelPriceDeltaValue: number;
  modelTextBasePrice: number;
  modifications?: ReadonlyArray<ModificationInput | null> | null;
  modifiedBy: number;
  modifiedOn?: string | null;
  name?: string | null;
  options?: ReadonlyArray<DesignOptionInput | null> | null;
  parentTemplateId?: number | null;
  pdSettings: number;
  pricingModelID: number;
  printTypeID: number;
  salesChannelID: number;
  sides?: ReadonlyArray<DesignSideInput | null> | null;
  sidesPrintTypes?: ReadonlyArray<DesignSidePrintTypeInput | null> | null;
  tags?: ReadonlyArray<string | null> | null;
  tempPreviewImageData?: string | null;
  tempPreviewImageUrl?: string | null;
  templateCode?: string | null;
  templateDesignID: number;
  uploadRestrictions?: UploadRestrictionInput | null;
  visitorCode?: string | null;
  visitorID: number;
};
export type UploadRestrictionInput = {
  isAiAllowed?: boolean | null;
  isEpsAllowed?: boolean | null;
  isFacebookAllowed?: boolean | null;
  isInstagramAllowed?: boolean | null;
  isJpgAllowed?: boolean | null;
  isPdfAllowed?: boolean | null;
  isPdfWithRasterAllowed?: boolean | null;
  isPngAllowed?: boolean | null;
  isSvgAllowed?: boolean | null;
  isUserImageAllowed?: boolean | null;
  resizeLargePdf?: boolean | null;
};
export type DesignElementsDescInput = {
  elements?: ReadonlyArray<DesignElementInput | null> | null;
  id?: string | null;
};
export type DesignElementInput = {
  image?: ImageDesignElementInput | null;
  shape?: ShapeDesignElementInput | null;
  tag?: string | null;
  text?: TextDesignElementInput | null;
  textArt?: TextArtDesignElementInput | null;
};
export type TextDesignElementInput = {
  adaptText?: boolean | null;
  content?: string | null;
  fillColor?: string | null;
  fontFamily?: string | null;
  fontSize?: number | null;
  fontStretch?: string | null;
  fontStyle?: string | null;
  fontWeight?: string | null;
  justification?: string | null;
  letterSpacing?: number | null;
  lineSpacing?: number | null;
  shadowAngle?: number | null;
  shadowBlur?: number | null;
  shadowColor?: string | null;
  shadowDistance?: number | null;
  strokeColor?: string | null;
  strokeWidth?: string | null;
  verticalAlignment?: string | null;
};
export type TextArtDesignElementInput = {
  content?: string | null;
};
export type ImageDesignElementInput = {
  imageID?: number | null;
};
export type ShapeDesignElementInput = {
  shapeID?: number | null;
};
export type ModificationInput = {
  designElementsDescID?: string | null;
  modelColorID: number;
  modificationID: any;
  variantNotMatched: boolean;
};
export type DesignOptionInput = {
  colorID: number;
  columns?: number | null;
  height?: number | null;
  id: number;
  rows?: number | null;
  sideID?: number | null;
  width?: number | null;
};
export type DesignCanvasRotationInput = {
  degrees: number;
  sideID: number;
};
export type DesignSideInput = {
  canAddImage: boolean;
  canAddShape: boolean;
  canAddText: boolean;
  canChangeSvgColors: boolean;
  canMaskImages: boolean;
  colorID: number;
  disableSellerImages: boolean;
  fillColor?: string | null;
  maxNrImages?: number | null;
  maxNrShapes?: number | null;
  maxNrTexts?: number | null;
  modelID: number;
  sideID: number;
  uploadRestrictions?: UploadRestrictionInput | null;
};
export type DesignSidePrintTypeInput = {
  colorID: number;
  modelID: number;
  printTypeID: number;
  sideID: number;
};
export type DesignAreaGridInput = {
  areaID: number;
  colorID: number;
  gridID: number;
  modelID: number;
  sideID: number;
};
export type DesignAreaInput = {
  areaID: number;
  colorID: number;
  modelID: number;
  printTypeID: number;
  sideID: number;
};
export type DesignItemInput = {
  applyImagePriceForQuantity?: boolean | null;
  areas?: ReadonlyArray<DesignItemAreaInput | null> | null;
  colorMappings?: ReadonlyArray<ColorMappingInput | null> | null;
  colors?: ReadonlyArray<DesignItemColorInput | null> | null;
  connectorSettings?: ReadonlyArray<ConnectorSettingInput | null> | null;
  constraints?: DesignItemConstraintsInput | null;
  defaultLCID: number;
  designItemTagType: DesignItemTagTypes;
  fillGradientSettings?: DesignItemFillGradientSettingsInput | null;
  fillImageSettings?: DesignItemFillImageSettingsInput | null;
  imageCustomerCode?: string | null;
  imageCustomerID: number;
  imageDpiX: number;
  imageDpiY: number;
  imageFileSize: number;
  imageFormat?: string | null;
  imageHeight: number;
  imageID: number;
  imageIsMulticolor: boolean;
  imagePreferredHeight?: number | null;
  imagePreferredWidth?: number | null;
  imagePrice: number;
  imageSellerID: number;
  imageType?: string | null;
  imageVisitorCode?: string | null;
  imageVisitorID: number;
  imageWidth: number;
  index: number;
  itemColors?: ReadonlyArray<string | null> | null;
  itemGuid?: string | null;
  itemID: number;
  json?: string | null;
  name?: string | null;
  overridePreview?: string | null;
  patternSettings?: DesignItemPatternSettingsInput | null;
  providerImageID?: string | null;
  shape?: DesignItemShapeInput | null;
  svg?: string | null;
  syncGuid?: string | null;
  tag?: string | null;
  textArt?: DesignItemTextArtInput | null;
};
export type ConnectorSettingInput = {
  key: string;
  settings?: string | null;
};
export type ColorMappingInput = {
  dest?: string | null;
  src?: string | null;
};
export type DesignItemAreaInput = {
  areaID: number;
  colorID: number;
  id?: string | null;
  modelID: number;
  sideID: number;
};
export type DesignItemColorInput = {
  colorCode?: string | null;
  colorID: number;
  imageID: number;
};
export type DesignItemConstraintsInput = {
  canAddMask: boolean;
  canChangeAdaptText: boolean;
  canChangeFontColor: boolean;
  canChangeFontFamily: boolean;
  canChangeFontItalic: boolean;
  canChangeFontSize: boolean;
  canChangeFontWeight: boolean;
  canChangeJustification: boolean;
  canChangeLetterSpacing: boolean;
  canChangeLineSpacing: boolean;
  canChangeMaskStrokeColor: boolean;
  canChangeMaskStrokeWidth: boolean;
  canChangeShadowAngle: boolean;
  canChangeShadowBlur: boolean;
  canChangeShadowColor: boolean;
  canChangeShadowDistance: boolean;
  canChangeShapeFillColor: boolean;
  canChangeShapeStrokeColor: boolean;
  canChangeShapeStrokeWidth: boolean;
  canChangeSvgColors: boolean;
  canChangeTextBoxMode: boolean;
  canChangeTextPathMode: boolean;
  canChangeTextStrokeColor?: boolean | null;
  canChangeTextStrokeWidth?: boolean | null;
  canChangeVerticalAlignment: boolean;
  canDelete: boolean;
  canDeleteMask: boolean;
  canDeleteShapeFilling: boolean;
  canEdit: boolean;
  canEditFilledShape: boolean;
  canEditMask: boolean;
  canEditMaskedImage: boolean;
  canEditShapeFilling: boolean;
  canFillShape: boolean;
  canMove: boolean;
  canReplaceMask: boolean;
  canReplaceShapeFilling: boolean;
  canResize: boolean;
  canResizeTextBox: boolean;
  canRotate: boolean;
  canStretch?: boolean | null;
  canSyncAlignment: boolean;
  canSyncContent: boolean;
  canSyncCurved: boolean;
  canSyncFontColor: boolean;
  canSyncFontFamily: boolean;
  canSyncFontStyle: boolean;
  canSyncTransforms: boolean;
  canTransform: boolean;
  canWrapTextOnAdaptText: boolean;
  isAlwaysOnBottom: boolean;
  isAlwaysOnTop: boolean;
  isPrintable: boolean;
  itemID: number;
  keepInPreview: boolean;
  keepNrChars: boolean;
  mandatoryToEdit: boolean;
  maxFontSize?: number | null;
  maxLetterSpacing?: number | null;
  maxLineSpacing?: number | null;
  maxNrChars: number;
  maxShadowAngle?: number | null;
  maxShadowBlur?: number | null;
  maxShadowDistance?: number | null;
  maxTextLines?: number | null;
  maxTextStrokeWidth?: number | null;
  minFontSize?: number | null;
  minLetterSpacing?: number | null;
  minLineSpacing?: number | null;
  minNrChars: number;
  minShadowAngle?: number | null;
  minShadowBlur?: number | null;
  minShadowDistance?: number | null;
  minTextStrokeWidth?: number | null;
  paddingString?: string | null;
  paddingTypeID: number;
  toUppercase: boolean;
};
export type DesignItemTextArtInput = {
  config?: TextArtConfigInput | null;
  fontFaceID: number;
  fontFamilyID: number;
  itemID: number;
  text?: string | null;
  textArtTypeID: number;
};
export type TextArtConfigInput = {
  angleValue: number;
  curveValue: number;
  intensB: number;
  intensT: number;
  isBottom: boolean;
  isBridge: boolean;
  isMiddle: boolean;
  isTop: boolean;
  isTriangle: boolean;
};
export type DesignItemShapeInput = {
  isMask: boolean;
  itemID: number;
  shapeID: number;
};
export type DesignItemPatternSettingsInput = {
  bounds?: ReadonlyArray<number> | null;
  flipX: boolean;
  flipY: boolean;
  offsetType: number;
  offsetX: number;
  offsetY: number;
  presetID: number;
  repeatX: boolean;
  repeatY: boolean;
  spacingX: number;
  spacingY: number;
};
export type DesignItemFillGradientSettingsInput = {
  centerX?: number | null;
  centerY?: number | null;
  gradientColors?: ReadonlyArray<string | null> | null;
  gradientStops?: ReadonlyArray<number> | null;
  radial: boolean;
  radius?: number | null;
  rotation?: number | null;
};
export type DesignItemFillImageSettingsInput = {
  horizontalFlip: boolean;
  imageID: number;
  leftPosition: number;
  rotation: number;
  scaling: number;
  scalingX: number;
  scalingY: number;
  syncRatio: boolean;
  topPosition: number;
  verticalFlip: boolean;
};
export type DesignTemplateCategoryInput = {
  categoryID: number;
  name?: string | null;
};
export type DesignTemplateColorInput = {
  colorID: number;
  isDefault: boolean;
  name?: string | null;
};
export type DesignClientPreviewInput = {
  fileObjectID: number;
  modificationID?: any | null;
  name?: string | null;
  sideID: number;
  url?: string | null;
};
export type DesignCameraScreenshotInput = {
  cameraLocationID: any;
  cameraName?: string | null;
  fileObjectID: number;
  modificationID?: any | null;
  sideID?: number | null;
  url?: string | null;
};
export type DesignTempPreviewInput = {
  designTempPreviewID: number;
  fileObjectID: number;
  modificationID: any;
  url?: string | null;
};
export type SelectedAdditionalAttributesInput = {
  metadata?: ReadonlyArray<KeyValuePairOfStringAndStringInput> | null;
  name?: string | null;
  price?: number | null;
  value?: string | null;
};
export type KeyValuePairOfStringAndStringInput = {
  key: string;
  value: string;
};
export type composerQueriesUpdateDesignTemplateMutation$variables = {
  design: DesignInput;
};
export type composerQueriesUpdateDesignTemplateMutation$data = {
  readonly updateDesignTemplate: {
    readonly id: string;
    readonly name: string | null;
  };
};
export type composerQueriesUpdateDesignTemplateMutation = {
  response: composerQueriesUpdateDesignTemplateMutation$data;
  variables: composerQueriesUpdateDesignTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "design"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "design",
        "variableName": "design"
      }
    ],
    "concreteType": "Design",
    "kind": "LinkedField",
    "name": "updateDesignTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesUpdateDesignTemplateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "composerQueriesUpdateDesignTemplateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d9d7d4c34e265e3041ca6406af0db85",
    "id": null,
    "metadata": {},
    "name": "composerQueriesUpdateDesignTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation composerQueriesUpdateDesignTemplateMutation(\n  $design: DesignInput!\n) {\n  updateDesignTemplate(design: $design) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d6a243ae04da58ed530735c67f5b54b";

export default node;
